import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

const Stats = () => {
  const { t } = useI18n();
  return (
    <section className="py-14 md:py-20 border-y border-[#E5E7EB] bg-white">
      <div className="zdc-container">
        <div className="mb-10 max-w-2xl">
          <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">{t.stats.eyebrow}</div>
          <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-[#111111]">
            {t.stats.title}
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E5E7EB] rounded-2xl overflow-hidden border border-[#E5E7EB]">
          {t.stats.items.map((s, i) => (
            <div key={i} className="p-6 md:p-8 bg-white">
              <div className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tighter text-[#111111]">
                {s.value}
              </div>
              <div className="mt-1.5 text-sm font-medium text-[#111111]">{s.label}</div>
              <div className="text-xs text-[#6B7280] mt-0.5">{s.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
